export default __webpack_public_path__ + "static/media/volunteer.44319afb.jpg";